import { BoxProps, ColorOptions, TextInputNewProps, TextNewProps } from '@jfs/ui-new'

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.2,
  shadowRadius: 4,
}

export const styles = {
  mainView: {
    flex: 1,
    backgroundColor: 'BACKGROUND_LIGHT',
    p: 20,
    pt: 30,
    overflow: 'scroll',
  } as BoxProps,
  textInputStyle: {
    borderColor: 'BORDER_COLOR' as ColorOptions,
    borderRadius: 6,
    fontFamily: 'jiotype-medium',
    labelColor: 'BLACK_21' as ColorOptions,
    fontSize: 14,
    paddingHorizontal: 8,
    focusBorderColor: 'PRIMARY' as ColorOptions,
    borderWidth: 1,
    paddingVertical: 8,
    onFocusBorderWidth: 1.5,
  } as TextInputNewProps,
  container: {
    underlayColor: 'WHITE',
    overflow: 'scroll',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    borderWidth: 1,
    borderRadius: 12,
    borderTopWidth: 0,
    paddingTop: 45,
    paddingBottom: 30,
    borderColor: '#e3e6f0' as ColorOptions,
    ...shadow,
  } as BoxProps,
  tickContainer: {
    justify: 'center',
    align: 'center',
    alignSelf: 'center',
  } as BoxProps,
  fundTransferredText: {
    fontSize: 18,
    fontFamily: 'jiotype-bold',
    color: "PRIMARY_STORNG",
    lineHeight: 28,
    textAlign: 'center',
  } as TextNewProps,
  transferContainer: {
    pt: 40,
    width: '70%',
    alignSelf: 'center',
  } as BoxProps,
  transactionId: {
    fontSize: 12,
    fontFamily: 'jiotype-medium',
    color: 'SECONDARY_GREY',
    textAlign: 'center',
  } as TextNewProps,
  transactionIdContainer: {
    alignSelf: 'center',
  } as BoxProps,
}
